import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssetError } from '@models/Core/Asset';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-asset-error',
  standalone: true,
  imports: [CommonModule, MessageModule],
  templateUrl: './asset-error.component.html',
  styleUrl: './asset-error.component.scss',
})
export class AssetErrorComponent {
  @Input() error?: AssetError;
}
